import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { updateLeaveType, leaveTypeQueryKeys } from '../api/leaveTypes.api';
import type { UpdateLeaveTypePayload } from '../types/leaveType.types';

interface UpdateLeaveTypeArgs {
  id: number;
  payload: UpdateLeaveTypePayload;
}

export function useUpdateLeaveType(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateLeaveTypeArgs) => updateLeaveType(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leaveTypeQueryKeys.all() });
      toast.success('Leave type updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update leave type');
    },
  });
}
